module.exports = __webpack_public_path__ + "img/US_SeigeArmor_ua.700a79b4.webp";